import VideoComp from "../videoComp/videoComp";
import ShopComp from "../shopComp/shopComp";
import ImgComp from "../imgComp/imgComp";
import Navigation from "../navigation/navigation";

//ASSETS
import marquise from "../../videos/marquise.mp4";

import img1 from "../../images/shopComp/comp3/img1.webp";
import img2 from "../../images/shopComp/comp3/img2.webp";
import img3 from "../../images/shopComp/comp3/img3.webp";
import img4 from "../../images/shopComp/comp3/img4.webp";

import Img_1 from "../../images/imgComp/imgComp3.webp";
import imgBg3 from "./images/bgs/marquise.webp";

export default function ThirdComp() {
  return (
    <>
      {/* <div className="allow-scroll demo"> */}
      {/* <Navigation /> */}

      <VideoComp
        id={3}
        header={"Bijuterii care fascinează"}
        idHeader={"the marquise"}
        text={
          <>
            <p>
              Ești un romantic incurabil, în căutarea unui inel de logodnă cu un
              aer aristocratic? <br />
              Tăietura diamantului în forma <b>Marquise</b> este dedicat femeii
              cu o personalitate debordantă, atrasă de tot ce este spectaculos
              în jurul ei.
            </p>
            <p>
              O tăietură specială, care amintește de forma ochiului uman cu un
              motiv: toate privirile vor rămâne ațintite asupra ta.
            </p>
          </>
        }
        // videoBg={imgBg3}
        videoBg={<img src={imgBg3} alt="" />}
        vidLink={marquise}
        href={
          "https://www.teilor.com/18k-white-gold-engagement-ring-with-0-8ct-and-0-452ct-diamonds-119585.html"
        }
        buttonText={"View the ring"}
      />
      <ShopComp
        ring_1={img1}
        href_1={
          "https://www.teilor.ro/lant-cu-pandant-din-aur-alb-de-14k-cu-diamante-de-0-35ct-119196.html"
        }
        ring_2={img2}
        href_2={
          "https://www.teilor.ro/inel-din-aur-roz-de-18k-cu-diamante-de-0-192ct-32778.html"
        }
        ring_3={img3}
        href_3={
          "https://www.teilor.ro/lant-cu-pandant-din-aur-roz-de-18k-cu-diamante-de-0-188ct-118824.html"
        }
        ring_4={img4}
        href_4={
          "https://www.teilor.ro/cercei-din-aur-alb-de-14k-cu-diamante-de-0-54ct-119194.html"
        }
        // mainLink={"https://www.teilor.ro/perpetual-love.html"}
      />
      <ImgComp
        img={Img_1}
        bgProp={"shape-3-bg"}
        // header={
        //   <>
        //     Arată cine ești și fii gata să strălucești. <br />
        //     <span>
        //       Răsfață-te cu bijuteriile care vorbesc despre tine. .
        //     </span>{" "}
        //     RING YOURSELF.
        //   </>
        // }
        // shape={<img className="shape-3" src={Svg_3}></img>}
        rightText1={<span style={{ color: "#B4B4B4" }}>Impozantă</span>}
        rightText2={<span style={{ color: "#797979" }}>Ambițioasă</span>}
        leftText1={<span style={{ color: "#484848" }}>Seducătoare </span>}
        leftText2={<span style={{ color: "#B4B4B4" }}>Curajoasă</span>}
        mainLink={"https://www.teilor.com/perpetual-love.html"}
      />
      {/* </div> */}
    </>
  );
}
